// extracted by mini-css-extract-plugin
export default {"menu-label":"ExplainedLabel_menu-label__c9q2A","explanation":"ExplainedLabel_explanation__0k238"};